export default __webpack_public_path__ + "static/media/beg2-removebg-preview.d8ddad80.png";